var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDoorman = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "doorman_svg__a",
  d: "M0 .918h21.565V22H0"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M24.59 14.245v4.208a3.16 3.16 0 0 1-3.16 3.16h-3.295a3.16 3.16 0 0 1-3.16-3.16v-4.208"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M16.127 21.073v1.01c0 1.088-.884 1.97-1.974 1.97M23.437 21.073v1.01c0 1.088.884 1.97 1.974 1.97"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M9.5 29v-2.595a2.35 2.35 0 0 1 2.351-2.352"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9 7)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "doorman_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#doorman_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M.845 21.498h20.312",
  mask: "url(#doorman_svg__b)"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M14.256 24.053h-2.405M30.065 29v-2.595a2.35 2.35 0 0 0-2.35-2.352M25.309 24.053h2.405"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m15.896 23.083 3.888 1.424M23.672 23.083l-3.889 1.424v3.99M17.529 16.684h.587M21.448 16.684h.59"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M19.782 8.418c-2.76 0-5 .943-5 2.106v3.201c0 .604 2.24 1.095 5 1.095 2.761 0 5-.49 5-1.095v-3.2c0-1.164-2.239-2.107-5-2.107Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M24.812 11.744c-.29.615-2.415 1.096-5.032 1.096-2.614 0-4.745-.481-5.032-1.096"
}))));
export default SvgDoorman;